module.exports = __webpack_public_path__ + "img/Réalisation d_un éclairage LED.f2699172.jpg";